import React, { useEffect } from "react";
import ImageBackground from "../../assets/images/Rectangle 42405.png";
import BoxOne from "../../assets/images/boxOne.webp";
import BoxTwo from "../../assets/images/boxTwo.webp";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import CopyLinkWithoutBackground from "../iFrame/copyLinkWithoutBackground";

const CustomSpesificSEction = ({ title }) => {
  const { i18n } = useTranslation();
  const direction = useLanguageDirection();

  const isExplainBuy = window.location.pathname.includes("/explain-buy");

  return (
    <div className="relative w-full">
      {/* Desktop Version */}
      <div
        className="hidden md:block relative w-full min-h-[350px]"
        dir={direction}
      >
        <img
          src={ImageBackground}
          alt="Background"
          className="object-cover w-full h-full"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 px-0 top-5">
          <div className="flex flex-row items-center justify-center w-full mt-4">
            <img
              src={direction === "rtl" ? BoxOne : BoxTwo}
              alt="box"
              className="relative h-20 -mt-4 right-5"
            />
            <div className="inline-block p-2 md:px-8 text-center bg-custom-yellow min-w-[400px]">
              <h2 className="text-3xl font-bold text-black">{title}</h2>
            </div>
            <img
              src={direction === "ltr" ? BoxOne : BoxTwo}
              alt="box"
              className="relative h-20 -mt-4 left-5"
            />
          </div>

          {isExplainBuy && (
            <div className="relative w-1/2 mt-2" dir={direction}>
              <CopyLinkWithoutBackground hiddenTitleGalbElhabeb={true} />
            </div>
          )}
        </div>
      </div>

      {/* Mobile Version */}
      <div
        className="relative w-full h-auto pb-10 overflow-x-hidden md:hidden"
        dir={direction}
      >
        {isExplainBuy && (
          <div
            className="block md:block relative w-full h-[300px]"
            dir={direction}
          >
            <img
              src={ImageBackground}
              alt="Background"
              className="object-cover w-full h-full"
            />
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 px-0 top-5">
              <div className="flex flex-row items-center justify-center w-full">
                <img
                  src={direction === "rtl" ? BoxOne : BoxTwo}
                  alt="box"
                  className="h-12 md:h-20 shrink-0"
                />
                <div className="inline-block p-2 px-4 md:px-8 text-center bg-custom-yellow w-full max-w-[350px] ">
                  <h2 className="text-lg font-bold text-black md:3xl">
                    {title}
                  </h2>
                </div>
                <img
                  src={direction === "ltr" ? BoxOne : BoxTwo}
                  alt="box"
                  className="h-12 md:h-20 shrink-0"
                />
              </div>

              {isExplainBuy && (
                <div className="relative w-3/4 mt-2" dir={direction}>
                  <CopyLinkWithoutBackground hiddenTitleGalbElhabeb={true} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomSpesificSEction;
